module.exports = __webpack_public_path__ + "img/icon_ky+ksvipslt.17a82865.png";